export default __webpack_public_path__ + "static/media/prev-earbuddyzultra.eade65ca.jpg";